module.exports = __webpack_public_path__ + "img/77334.00f0c67c.svg";